<template>
  <div id='app'>
    <Layout v-if='isRouterAlive'></Layout>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Layout from '@/framework/layout'

export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true,
      jsUrl: [{
        url: 'static/js/strength.libs.js'
      }, {
        url: 'static/js/strengths.js'
      }]
    }
  },
  components: {
    Layout
  },
  methods: {
    // ...mapActions(['onLogin']),
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    async addScript() {
      let hasScript = await this.checkScript()
      let jsUrl = this.jsUrl
      if (!hasScript) {
        for (let i = 0; i < jsUrl.length; i++) {
          // console.log(jsUrl[i])
          const jsDom = document.createElement('script')
          jsDom.type = 'text/javascript'
          jsDom.src = jsUrl[i].url
          document.body.appendChild(jsDom)
        }
      }
    },
    checkScript() {
      const jsDom = Array.from(document.getElementsByTagName('script'))
      let hasScript = false
      for (let i = 0; i < jsDom.length; i++) {
        // console.log('js11', jsDom[i])
        if (jsDom[i].src.toString().indexOf('strength') !== -1) {
          // jsDom[i].remove()
          hasScript = true
        }
      }
      // console.log('clearScript', jsDom)
      return hasScript
    }
  },
  created() {
    if (localStorage.getItem('lang')) {
      // this.$store.replaceState(Object.assign({}, this.$store.state, localStorage.getItem('lang')))
      this.$store.commit('SAVE_LANG', JSON.parse(localStorage.getItem('lang')))
    }

    // if (localStorage.IMinfo) {
    //   this.onLogin({
    //     username: JSON.parse(localStorage.IMinfo).username,
    //     password: JSON.parse(localStorage.IMinfo).password,
    //   })
    // }
    // // 初始化聊天记录缓存
    // if (!localStorage.msgList) {
    //   localStorage.msgList = JSON.stringify({})
    // }
    // if (localStorage.currentChatId) {
    //   localStorage.removeItem('currentChatId')
    //   this.$store.commit('CLEAR_CURRENTCHAT_ID')
    // }

    if (window.location.href.indexOf('ourAdvantages') !== -1) {
      this.addScript()
    }
  },
  mounted() {
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('lang', JSON.stringify(this.$store.state.language))
    })

  }

}
</script>

<style lang='less'>
@import './framework/style/dialog.less';
@import './framework/style/table.less';
@import './framework/style/layoutLeft.less';
@import './framework/style/button.less';
@import './framework/style/card.less';
@import './framework/style/form';
@import './framework/style/tabs';
@import './framework/style/step';
@import './project/styles/style.less';

#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial,
  sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue